var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(512.082 -162.704) scale(.76584)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -472.783,
    cy: 341.256,
    r: 107.567,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 17.21711159,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -472.783,
    cy: 341.627,
    r: 87.813,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a_pin2",
    d: "M-93.33-74.125a163.919 163.919 0 0 1-224.594-13.082 163.919 163.919 0 0 1 0-224.975A163.919 163.919 0 0 1-93.33-325.263",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 125.71019745,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "matrix(.10477 0 0 .08588 -506.329 359.108)"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a_pin2",
    id: "b_pin2",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    transform: "rotate(-60 -472.858 342.066)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_pin2",
    id: "c_pin2",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    transform: "rotate(-60 -473.886 342.721)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c_pin2",
    id: "d_pin2",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    transform: "rotate(-60 -473.886 342.721)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d_pin2",
    id: "e_pin2",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    transform: "rotate(-60 -473.886 342.721)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e_pin2",
    width: "100%",
    height: "100%",
    transform: "rotate(-60 -473.886 342.721)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -472.931,
    cy: 341.516,
    r: 18.188,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 12.28584385,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512.082 39.796) scale(.76584)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -472.783,
    cy: 341.256,
    r: 107.567,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 17.21711159,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -472.783,
    cy: 341.627,
    r: 87.813,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.33-74.125a163.919 163.919 0 0 1-224.594-13.082 163.919 163.919 0 0 1 0-224.975A163.919 163.919 0 0 1-93.33-325.263",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 125.71019745,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "matrix(.10477 0 0 .08588 -506.329 359.108)"
  }), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a_pin2",
    width: "100%",
    height: "100%",
    transform: "rotate(-60 -472.858 342.066)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_pin2",
    width: "100%",
    height: "100%",
    transform: "rotate(-60 -473.886 342.721)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c_pin2",
    width: "100%",
    height: "100%",
    transform: "rotate(-60 -473.886 342.721)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d_pin2",
    width: "100%",
    height: "100%",
    transform: "rotate(-60 -473.886 342.721)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e_pin2",
    width: "100%",
    height: "100%",
    transform: "rotate(-60 -473.886 342.721)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -472.931,
    cy: 341.516,
    r: 18.188,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 12.28584385,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin2);
export default __webpack_public_path__ + "static/media/Pin2.d9d982aab453c393f43acd2a0b391a1f.svg";
export { ForwardRef as ReactComponent };